import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { GetUsersApi, GetVendorListAPI, MyAccounts, UpdateUserApi } from "../../common/CommonApi";
import { Button, ButtonRow, CheckboxLabel, Dropdown, DropdownWrapper, Field, Input, Item, Label, ModalContent, ModalOverlay, Option, OptionsList, SelectBox, SelectedItems, TableRowProduct } from "../../styles/common";
import { AdminRoleBadge, JoinDate, StatItem, StatLabel, StatNumber, TableHeader, TableRow, UserActions, UserAvatar, UserDetails, UserEmail, UserInfo, UserName, UsersStats, UsersTable } from "../../styles/UsersStyles";
import { getStatusBadge } from "../../common/common";
import { Navigate, useNavigate } from "react-router-dom";
const Container = styled.div`
  padding: 24px;
  background: #f9fafb;
  min-height: 100vh;

  @media (max-width: 768px) {
    padding: 0;
    min-height: auto;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
`;

const SearchInput = styled.input`
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  outline: none;
`;

const TableWrapper = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  overflow: hidden;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Th = styled.th`
  text-align: left;
  padding: 12px 16px;
  background: #f3f4f6;
`;

const Td = styled.td`
  padding: 12px 16px;
  border-top: 1px solid #eee;
`;

const ActionButton = styled.button`
  padding: 6px 12px;
  font-size: 14px;
  border:none;
  border-radius: 6px;
  background: #fef3c7;
  cursor: pointer;
  &:hover {
    background: #fde68a;
  }
`;


const Tag = styled.div`
  background: #007bff;
  color: white;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

const RemoveBtn = styled.span`
  cursor: pointer;
  font-weight: bold;
`;

const VENDOR_TABLE_COLUMNS = '1.4fr 1.6fr 0.8fr 1fr 0.8fr 1.3fr 1.1fr';

const VendorTableHeader = styled(TableHeader)`
  grid-template-columns: ${VENDOR_TABLE_COLUMNS};
  min-width: 920px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const VendorTableRow = styled(TableRow)`
  grid-template-columns: ${VENDOR_TABLE_COLUMNS};
  min-width: 920px;

  @media (max-width: 768px) {
    min-width: 0;
    grid-template-columns: 1fr 1fr;
    margin: 10px;
    padding: 14px;
    border: 1px solid #e2e8f0;
    border-radius: 10px;

    > * {
      min-width: 0;
      overflow-wrap: anywhere;
    }

    > :nth-child(n + 2)::before {
      display: block;
      margin-bottom: 4px;
      color: #94a3b8;
      font-size: 10px;
      font-weight: 700;
      text-transform: uppercase;
    }

    > :nth-child(2)::before { content: "Email"; }
    > :nth-child(3)::before { content: "Role"; }
    > :nth-child(4)::before { content: "Documents"; }
    > :nth-child(5)::before { content: "Status"; }
    > :nth-child(6)::before { content: "Joined"; }
    > :nth-child(7)::before { content: "Actions"; }
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
export const ModalContentForView = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 600px;
  max-width: 100%;
  max-height: calc(100dvh - 40px);
  overflow-y: auto;
`;

export const VendorList = () => {
  const [users, setUsers] = useState([]);
  const [loading,setLoading] = useState(false)
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [form, setForm] = useState({});
  const [roles, setRoles] = useState("");
  const [selected, setSelected] = useState([]);
  const [vendorDetails, setVendorDetails] = useState({});
  const [open, setOpen] = useState(false);

  const toggleSelection = (item) => {
    if (selected.includes(item)) {
      // remove if already selected
      setSelected(selected.filter((val) => val !== item));
    } else {
      // add new selection
      setSelected([...selected, item]);
    }
  };

  const removeItem = (item) => {
    setSelected(selected.filter((val) => val !== item));
  };

  useEffect(() => {
    GetUserList(); // only once on mount
  }, []);

  useEffect(() => {
    if (editingUser) {
      setForm({
        fullname: editingUser.fullname || "",
        email: editingUser.email || "",
        role: editingUser.role || "",
        permissions: editingUser.permissions || [],
        isActive: !!editingUser.isActive,
      });
      setRoles(editingUser.role || "");              // ✅ set current role
      setSelected(editingUser.permissions || []);    // ✅ set current permissions
      GetUserList();
    } else {
      setForm({});
      setRoles("");
      setSelected([]);
      GetUserList();
    }
  }, [editingUser]);

  const GetUserList = async () => {
    setLoading(true)
    let response = await GetVendorListAPI()
    setUsers(response.data.data)
    setLoading(false)
  }
  const  navigate = useNavigate()

  function closeModal() {
    setIsOpen(false);
    setEditingUser(null);
  }

  const getDocsStatusLabel = (user) => {
    if (user.isDocs) return "Verified";
    if (user.isDocsPending) return "Pending Review";
    if (user.accountNumber || user.bankName || user.govtId) return "Uploaded";
    return "Not Submitted";
  };

  const filtered = users.filter(
    (u) => u.fullname.toLowerCase().includes(query.toLowerCase()) || u.email.toLowerCase().includes(query.toLowerCase())
  );

  const HandleView = (data) => {
    setIsOpen(true)
    setVendorDetails(data)
  }
  return (
    <Container>
      <UsersStats>
              <StatItem>
                <StatNumber>{filtered.length}</StatNumber>
                <StatLabel>Total Users</StatLabel>
              </StatItem>
              <StatItem>
                <StatNumber>{filtered.filter(u => u.accountStatus === false).length}</StatNumber>
                <StatLabel>Active Users</StatLabel>
              </StatItem>
              <StatItem>
                <StatNumber>{users.filter(u => u.role === 'Admin').length}</StatNumber>
                <StatLabel>Pending Status</StatLabel>
              </StatItem>
            </UsersStats>
      <Header>
        {/* <Title>Vendors</Title>
        <SearchInput
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search by name or email..."
        /> */}
      </Header>
      <UsersTable>
        <VendorTableHeader>
          <div>Name</div>
          <div>Email</div>
          <div>Role</div>
          <div>Docs Status</div>
          <div>Status</div>
          <div>Join Date</div>
          <div>Actions</div>
        </VendorTableHeader>
        {
          loading &&
          <div style={{display:"flex",justifyContent:"center"}}>
            <img src="/assets/loading.gif"/>
          </div>
        }
        {filtered.map(user => (
          <VendorTableRow key={user.id}>
            <UserInfo>
              <UserAvatar style={{ background: '#37f5ffff' }}>🕴🏻</UserAvatar>
              <UserDetails>
                <UserName>{user.fullname}</UserName>
              </UserDetails>
            </UserInfo>
            <UserEmail>{user.email}</UserEmail>
            <div>
              <AdminRoleBadge>{user.role}</AdminRoleBadge>
            </div>
            <div>
              <AdminRoleBadge style={{
                background: user.isDocs ? '#d1f2eb' : user.isDocsPending ? '#fcf3cf' : '#f3f4f6',
                color: user.isDocs ? '#16a085' : user.isDocsPending ? '#b9770e' : '#555',
              }}>
                {getDocsStatusLabel(user)}
              </AdminRoleBadge>
            </div>
            <div>
              {getStatusBadge(user.isActive)}
            </div>
            <JoinDate>{new Date(user.createdDate).toLocaleString()}</JoinDate>
            <UserActions>
              <ActionButton className="view" onClick={()=>navigate(`/vendor/view?id=${user._id}`)}>View</ActionButton>
              <ActionButton className="verify" onClick={()=>navigate(`/vendor/manage?id=${user._id}`)}>Verify</ActionButton>
            </UserActions>
          </VendorTableRow>
        ))}
      </UsersTable>
      {isOpen && (
        <ModalOverlay>
          <ModalContentForView>
           <div style={{display:"flex",justifyContent:"space-between"}}>
             <h2>Vendor {vendorDetails.fullname}</h2>
              <p onClick={()=>setIsOpen(false)} style={{fontSize:"20px",cursor:"pointer"}}>⤫</p>
           </div>
            <TableRowProduct cols={2}>
            <Field>
              <Label>Full Name</Label>
              <Input name="fullname" value={vendorDetails.fullname} disabled />
            </Field>
            <Field>
              <Label>Email</Label>
              <Input name="email" value={vendorDetails.email} disabled />
            </Field>
            <Field>
              <Label>Brand Name</Label>
              <Input name="email" value={vendorDetails.companyName} disabled />
            </Field>
            <Field>
              <Label>Created At</Label>
              <Input name="email" value={new Date(vendorDetails.createdDate).toLocaleString()} disabled />
            </Field>
            <Field>
              <Label>Role</Label>
              <Input name="email" value={vendorDetails.role} disabled />
            </Field>
            <Field>
              <Label>Status</Label>
              <Input name="email" value={vendorDetails.isActive ? 'YES' :'NO'} disabled />
            </Field>
            </TableRowProduct>
          </ModalContentForView>
        </ModalOverlay>
      )}
    </Container>
  );
};
